import React, { useRef } from "react";
import { Form, Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import CustomReactSelect from "../../../components/CustomReactSelect";

const StatusBar = (props) => {
	const startDatepickerRef = useRef(null);
	const endDatepickerRef = useRef(null);
	const openStartDatepicker = () => {
		const datepickerElement = startDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	const openEndDatepicker = () => {
		const datepickerElement = endDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	return (
		<Row className="status-bar">
			{/*Employee Name */}
			<Col lg={4}>
				<Form.Group className="input-Field">
					<Form.Label className="label">Employee Name</Form.Label>
					<Col>
						<CustomReactSelect
							options={props.status}
							value={props.selectedEmp}
							onChange={(obj) => props.handleStatus(obj)}
							isSearchable={false}
							placeholder="Select"
						/>
					</Col>
				</Form.Group>
			</Col>

			{/*Start Date */}
			<Col lg={4}>
				<Form.Group className="input-Field">
					<Form.Label className="label">Start Date</Form.Label>
					<Col className="datepicker-wrapper">
						<DatePicker
							showYearDropdown
							showMonthDropdown
							dateFormatCalendar=" " //for title
							name="startDate"
							className="custom-container"
							onChange={props.startDateHandleChange}
							selected={props.startDate}
							value={props.startDate}
							dateFormat="dd/MM/yyyy"
							autoComplete="off"
							clearIcon={null}
							calendarIcon={null}
							isOpen={props.startDateCalendar}
							maxDate={new Date()}
							ref={startDatepickerRef}
						/>
						<FontAwesomeIcon
							icon={faCalendarAlt}
							className="calender"
							color="keppel"
							onClick={() => openStartDatepicker()}
						/>
					</Col>
				</Form.Group>
			</Col>

			{/*End Date */}
			<Col lg={4}>
				<Form.Group className="input-Field">
					<Form.Label className="label">End Date</Form.Label>
					<Col className="datepicker-wrapper">
						<DatePicker
							showYearDropdown
							showMonthDropdown
							dateFormatCalendar=" " //for title
							className="custom-container"
							selected={props.endDate}
							onChange={props.endDateHandleChange}
							name="endDate"
							dateFormat="dd/MM/yyyy"
							autoComplete="off"
							value={props.endDate}
							clearIcon={null}
							calendarIcon={null}
							isOpen={props.endDateCalendar}
							minDate={props.startDate}
							maxDate={new Date()}
							ref={endDatepickerRef}
						/>
						<FontAwesomeIcon
							icon={faCalendarAlt}
							className="calender"
							color="keppel"
							onClick={() => openEndDatepicker()}
						/>
					</Col>
				</Form.Group>
			</Col>
		</Row>
	);
};

export default StatusBar;
